export { getPlatformName } from "./getPlatformName/getPlatformName";
export { formatGeneration } from "./formatGeneration/formatGeneration";
export {
    loadCompareCountFromLocalStorage,
    saveCompareCountToLocalStorage,
    saveCompareOffersToLocalStorage
} from "./localStorageCompare/localStorageCompare";